import {
  consultaInicial,
  executeFieldAction,
  selectCamposSolicitud,
  selectDatosSolicitud,
  selectDescripcionesSolicitud,
  setCampoValidando,
  setDatoSolicitud,
} from 'features/solicitudes/solicitudesSlice'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { validate } from '../../libs/FieldResquestValidator'
import {
  getValoresConsulta,
  processValidationResult,
  todosLosPadresTienenValor,
} from '../../libs/SolicitudesHelpers'
import ValidatingText from '../ValidatingText'

import axios from 'api/axios'

import ClearIcon from '@mui/icons-material/Clear'
import SearchIcon from '@mui/icons-material/Search'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import IconButton from '@mui/material/IconButton'
import Input from '@mui/material/Input'
import InputAdornment from '@mui/material/InputAdornment'

import { Alert, Box, TextField } from '@mui/material'
import CustomTable from 'common/components/CustomTable'
import LabelComponent from '../LabelComponent'

function ListOfValuesComponent({ idpk }) {
  const dispatch = useDispatch()
  const campos = useSelector(selectCamposSolicitud)
  const campo = campos.filter((c) => c.idpk === idpk)[0]

  const datos = useSelector(selectDatosSolicitud)
  const valor = datos[campo.idpk]

  const descripciones = useSelector(selectDescripcionesSolicitud)
  const descripcion = descripciones[campo.idpk]

  const [value, setValue] = useState(campo.valor_dfto || '')
  const [open, setOpen] = useState(false)
  const [lvLoading, setLvLoading] = useState(false)
  const [titulo, setTitulo] = useState('')
  const [etiqueta1, setEtiqueta1] = useState('')
  const [etiqueta2, setEtiqueta2] = useState('')
  const [registros, setRegistros] = useState([])
  const [error, setError] = useState('')
  const [filterText, setFilterText] = useState('')

  // La inicialización ahora se hace de forma centralizada en CamposSolicitud
  // mediante el endpoint /inicializasolicitud/

  useEffect(() => {
    const processValueChange = async () => {
      // Si hay valor, validar primero
      if (valor) {
        try {
          // Activar estado de validación
          dispatch(setCampoValidando({ idpk: campo.idpk, validando: true }))

          const result = await validate(campo, valor, campos, datos)
          processValidationResult(result, campo, valor, dispatch, descripcion)
        } catch (error) {
          // Si hay error de validación, limpiar el campo y no ejecutar el resto
          setValue('')
          dispatch(setDatoSolicitud({ idpk: campo.idpk, valor: null, descripcion: '' }))
          return
        } finally {
          // Desactivar estado de validación
          dispatch(setCampoValidando({ idpk: campo.idpk, validando: false }))
        }
      }

      // Ejecutar consultaInicial para campos dependientes solo si:
      // 1. El campo tiene valor
      // 2. El campo dependiente necesita inicialización (inicializando === 'P')
      // 3. El campo dependiente NO está siendo inicializado por inicializaSolicitud (inicializando !== 'R')
      campos.forEach((c) => {
        if (
          c.depende_de &&
          c.depende_de.includes(campo.codigo_campo) &&
          valor &&
          c.inicializando === 'P' &&
          todosLosPadresTienenValor(c, campos, datos)
        ) {
          dispatch(consultaInicial({ idpk: c.idpk, valores: getValoresConsulta(datos, campos) }))
        }
      })
      setValue(descripcion)
      campo.acciones.forEach((action) => {
        if (
          action.valor_referencia === valor ||
          (action.valor_referencia === 'NOT_NULL' && valor) ||
          (action.valor_referencia === 'NULL' && !valor)
        ) {
          dispatch(executeFieldAction({ action }))
        }
      })
    }

    processValueChange()
    // eslint-disable-next-line
  }, [valor])

  const handleSearch = () => {
    if (valor) {
      setValue('')
      dispatch(setDatoSolicitud({ idpk: campo.idpk, valor: null }))
      return
    }
    setLvLoading(true)
    axios
      .post(`/consultalov/${idpk}/`, {
        valores: getValoresConsulta(datos, campos),
        busqueda: value,
      })
      .then((request_response) => {
        const data = request_response.data
        /**@type {Array<LovItem>} */
        const registros = data.registros

        // @ts-ignore
        setRegistros(registros)
        setTitulo(data.titulo)
        setEtiqueta1(data.etiqueta_1)
        setEtiqueta2(data.etiqueta_2)

        if (registros && registros.length === 1) return handleListItemClick(registros[0])

        setFilterText('')
        setOpen(true)
      })
      .catch((error) => setError(error))
      .finally(() => setLvLoading(false))
  }

  /**
   * @param {LovItem} r - Valor de la lista de valores seleccionado
   */
  const handleListItemClick = (r) => {
    setValue(r.descripcion)
    setOpen(false)
    dispatch(setDatoSolicitud({ idpk: campo.idpk, valor: r.codigo, descripcion: r.descripcion }))
  }

  const handleOnChange = (e) => {
    setValue(e.target.value)
  }

  const handleOnBlur = (e) => {
    if (!valor) {
      handleSearch()
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  if (campo) {
    return error ? (
      <Alert severity="error">Se ha producido un error durante la consulta de datos</Alert>
    ) : (
      <>
        <FormControl variant="standard" error={campo.error} sx={{ width: '100%' }}>
          <LabelComponent text={campo.etiqueta} obligatorio={campo.obligatorio} />
          <Input
            key={`lv-${campo.idpk}`}
            id={`lv-${campo.idpk}`}
            type="text"
            value={value}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            disabled={
              valor || campo.informativo === 'S' || campo.cargando || campo.validando ? true : false
            }
            error={campo.error ? true : false}
            endAdornment={
              <InputAdornment position="end">
                <IconButton aria-label="abrir lista de valores" onClick={handleSearch}>
                  {lvLoading || campo.cargando ? (
                    <CircularProgress size={20} />
                  ) : valor ? (
                    <ClearIcon color={campo.error ? 'error' : ''} />
                  ) : (
                    <SearchIcon color={campo.error ? 'error' : ''} />
                  )}
                </IconButton>
              </InputAdornment>
            }
          />
          <FormHelperText id={`lv-${campo.idpk}-ayuda`}>
            {campo.validando ? <ValidatingText /> : campo.ayuda}
          </FormHelperText>
        </FormControl>
        <Dialog
          onClose={handleClose}
          open={open}
          maxWidth={false}
          PaperProps={{
            sx: {
              minWidth: '50%',
              maxWidth: '90vw',
              width: 'fit-content',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: { xs: 'wrap', sm: 'nowrap' },
              gap: 2,
              px: 3,
              pt: 2,
              pb: 1,
            }}
          >
            <DialogTitle sx={{ p: 0, width: { xs: '100%', sm: 'auto' }, flex: { sm: 1 } }}>
              {titulo}
            </DialogTitle>
            <TextField
              size="small"
              variant="outlined"
              placeholder="Filtrar..."
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon sx={{ fontSize: '1.2rem' }} />
                    </InputAdornment>
                  ),
                },
              }}
              sx={{ width: { xs: '100%', sm: '50%', md: '30%' } }}
            />
          </Box>
          <DialogContent>
            <CustomTable
              hideFooter={false}
              initialPageSize={12}
              dataSource={
                filterText
                  ? (registros ?? []).filter((r) => {
                      const text = filterText.toLowerCase()
                      return (
                        r.codigo?.toString().toLowerCase().includes(text) ||
                        r.descripcion?.toString().toLowerCase().includes(text)
                      )
                    })
                  : (registros ?? [])
              }
              checkbox={false}
              fields={[
                { value: 'codigo', key: etiqueta1, sortable: true, flex: 1 },
                { value: 'descripcion', key: etiqueta2, sortable: true, flex: 2 },
              ]}
              onClickEvent={(params) => {
                handleListItemClick(params.row)
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancelar</Button>
          </DialogActions>
        </Dialog>
      </>
    )
  }
}

export default ListOfValuesComponent
